export type Language = 'en' | 'id';

const STORAGE_KEY = 'rekayasa_lang';

const isLanguage = (value: unknown): value is Language => value === 'en' || value === 'id';

export const detectBrowserLanguage = (): Language => {
  const languages = typeof navigator !== 'undefined' ? navigator.languages : undefined;
  const primary = typeof navigator !== 'undefined' ? navigator.language : undefined;

  const candidates = [
    ...(Array.isArray(languages) ? languages : []),
    ...(typeof primary === 'string' ? [primary] : []),
  ];

  const normalized = candidates
    .filter((l): l is string => typeof l === 'string')
    .map((l) => l.toLowerCase());

  return normalized.some((l) => l === 'id' || l.startsWith('id-')) ? 'id' : 'en';
};

export const loadLanguage = (): Language => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isLanguage(stored)) return stored;
  } catch {
    // ignore
  }
  return detectBrowserLanguage();
};

export const saveLanguage = (lang: Language) => {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // ignore
  }
};

